import {
  createSystem,
  defaultBaseConfig,
  defineConfig,
} from "@chakra-ui/react-v3";

import { breakpoints } from "./breakpoints";
import { keyframes } from "./keyframes";
import { globalCss } from "./global-css";
import { textStyles } from "./text-styles";

import { recipes } from "./recipes";
import { slotRecipes } from "./slot-recipes";

import { semanticColors } from "./semantic-tokens/colors";

import { colors } from "./tokens/colors";
import { radii } from "./tokens/radius";
import { sizes } from "./tokens/sizes";
import { spacing } from "./tokens/spacing";
import { durations, easings } from "./tokens/transitions";
import {
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
} from "./tokens/typography";

const tokens = {
  colors,
  durations,
  easings,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  radii,
  sizes,
  spacing,
};

const semanticTokens = {
  colors: semanticColors,
};

const config = defineConfig({
  cssVarsPrefix: "tiger-ui",
  cssVarsRoot: ":where(html, .chakra-theme)",
  // Keep Chakra v3's styles unlayered so they stay on equal footing with
  // Chakra v2's (also unlayered) css-reset. See `preflight` below.
  disableLayers: true,

  /**
   * Chakra v3's preflight is redundant while Chakra v2 is still mounted above
   * us in `App.tsx` — v2's css-reset already normalizes box-sizing, borders,
   * margins and buttons. Worse, because `disableLayers` puts v3's preflight in
   * the unlayered bucket, its `[type='button'] { background-color: transparent }`
   * rule ties on specificity (0,1,0) with the query widget's `.bg-button-primary`
   * utility and wins on source order, rendering widget buttons invisible until
   * hovered (the `:hover` utility is 0,2,0, so it still applies).
   *
   * Scoping the preflight doesn't help: a scope prefix *raises* specificity to
   * (0,1,1), which beats the widget's utilities outright.
   */
  preflight: false,

  theme: {
    tokens,
    semanticTokens,

    recipes,
    slotRecipes,

    breakpoints,
    keyframes,
    textStyles,
  },

  globalCss,
});

export const system = createSystem(defaultBaseConfig, config);
